import { JoinMeetingDialog } from "./JoinMeetingDialog";

interface JoinMeetingViewProps {
  showJoinDialog: boolean;
  onOpenChange: (open: boolean) => void;
  onJoin: (name: string, userId: string) => Promise<boolean>;
  meetingCode: string;
  error?: string | null;
}

export const JoinMeetingView = ({
  showJoinDialog,
  onOpenChange,
  onJoin,
  meetingCode,
  error,
}: JoinMeetingViewProps) => {
  return (
    <>
      <JoinMeetingDialog
        open={showJoinDialog}
        onOpenChange={onOpenChange}
        onJoin={onJoin}
        meetingCode={meetingCode}
      />
      <div className="flex h-screen items-center justify-center bg-background p-4">
        <div className="text-center max-w-md w-full">
          {error ? (
            <>
              <div className="mb-4 text-3xl sm:text-4xl">⚠️</div>
              <h2 className="mb-2 text-lg sm:text-xl font-semibold text-destructive">
                Lỗi kết nối
              </h2>
              <p className="mb-4 text-sm sm:text-base text-muted-foreground">
                {error}
              </p>
              <p className="text-xs sm:text-sm text-muted-foreground">
                Vui lòng nhập lại thông tin để thử kết nối lại
              </p>
            </>
          ) : (
            <p className="text-sm sm:text-lg font-medium">
              Vui lòng nhập thông tin để tham gia cuộc họp
            </p>
          )}
        </div>
      </div>
    </>
  );
};

